 angular.module('billing').controller('PaymentOptionsCtrl',
                ['$scope','$state', '$stateParams', 'PatientPortalStorageRepository', 'BillingRepository', 'BillingService', 'TransitionManager', 'aprgettext',
        function ($scope,  $state,   $stateParams,   PatientPortalStorageRepository,   BillingRepository,   BillingService,   TransitionManager,   gettext) {

            'use strict';

            var loginUserId = PatientPortalStorageRepository.getLoginUser().id;
            $scope.loadingBillingAccount = true;
            $scope.paymentMethodSelect = null;
            $scope.viewMakeAPaymentFeature = true;
            $scope.model = {
                Date: '',
                HasCardOnFile: false,
                PaymentMethodSelect: '',
                PersonBalanceAll: '',
                ConsentAnnual: null,
                PaymentHistory: [],
            };
            $scope.PaymentMethodList = [
                {
                    Name: gettext('Use A Different Card'),
                    ConsentId: '0'
                }
            ];
            $scope.model.PaymentMethodSelect = $scope.PaymentMethodList[0];
            $scope.statementsOnly = getState();

            function getState()
            {
                  return $state.current.alternativeLoginRoute;
            }


            function loadPage() {
                loginUserId = PatientPortalStorageRepository.getLoginUser().id;
                loadBillingAccount();
                loadPaymentHistory();
            }

            function loadPaymentHistory() {
                $scope.loadingPaymentHistory = true;
                var requestDto = {
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString()
                };

                return BillingRepository
                    .getPaymentHistory(requestDto)
                    .then(function (paymentHistoryArray) {
                        if (paymentHistoryArray) {
                            $scope.model.PaymentHistory = _(paymentHistoryArray.plain()).map(function (entry) {
                                return _.assign(entry, {Downloading : false});
                            }).value();
                        }
                    })
                    .finally(function () {
                        $scope.loadingPaymentHistory = false;
                    });
            }

            function loadBillingAccount() {
                $scope.loadingBillingAccount = true;
                $scope.removeHttpError();

                var requestDto = {
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString()
                };

                BillingService
                    .getBillingAccount(requestDto)
                    .then(function (billingAccountDto) {
                        $scope.model.PersonBalanceAll = $stateParams.amount;
                        if (billingAccountDto.ConsentAnnual && billingAccountDto.ConsentAnnual.CardType) {
                            $scope.model.ConsentAnnual = billingAccountDto.ConsentAnnual;
                            $scope.PaymentMethodList = [
                                {
                                    Name: $scope.model.ConsentAnnual.CardType + ' ' + $scope.model.ConsentAnnual.Mask + ' ' + $scope.model.ConsentAnnual.ExpDate,
                                    ConsentId: $scope.model.ConsentAnnual.ConsentId
                                },
                                {
                                    Name: gettext('Use A Different Card'),
                                    ConsentId: '0'
                                }
                            ];
                            $scope.model.PaymentMethodSelect = null;
                            $scope.model.HasCardOnFile = true;
                            $scope.model.Date = billingAccountDto.Date;
                        }
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loadingBillingAccount = false;
                    });
            }

            function paymentMethodSelected() {
                $scope.statementsOnly = getState();

                if ($scope.model.PaymentMethodSelect.ConsentId && $scope.model.PaymentMethodSelect.ConsentId === '0') {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({
                            appRoute: 'paymentFromNewCardStatementsOnly',
                            opts: {amount: $scope.model.PersonBalanceAll}
                        });
                    }
                    else{
                        TransitionManager.transition({appRoute: 'paymentFromNewCard'});
                    }
                }
                else if ($scope.model.ConsentAnnual) {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({
                            appRoute: 'paymentFromConsentStatementsOnly',
                            opts: {consentId: $scope.model.ConsentAnnual.ConsentId}
                        });
                    }
                    else {
                            TransitionManager.transition({
                                appRoute: 'paymentFromConsent',
                                opts: {consentId: $scope.model.ConsentAnnual.ConsentId}
                            });
                    }
                }
            }

            $scope.paymentMethodSelected = paymentMethodSelected;
            $scope.loadPaymentHistory = loadPaymentHistory;
            loadPage();
        }
    ]
);